module.exports = __webpack_public_path__ + "static/media/Laptop.dff00f90.svg";